import Dexie, { type Table } from "dexie";

import type {
  AnnotationRecord,
  DocumentRecord,
  PageTextCacheRecord,
  PdfBlobRecord,
  ReadingStateRecord,
  SettingsRecord,
} from "@/domain";

import {
  MARGINALIA_DATABASE_NAME,
  MARGINALIA_DATABASE_VERSION,
  SCHEMA_V1,
} from "./schema-v1";

export class MarginaliaDatabase extends Dexie {
  declare documents: Table<DocumentRecord, string>;
  declare pdfBlobs: Table<PdfBlobRecord, string>;
  declare annotations: Table<AnnotationRecord, string>;
  declare readingStates: Table<ReadingStateRecord, string>;
  declare pageTextCache: Table<PageTextCacheRecord, string>;
  declare settings: Table<SettingsRecord, "application">;

  constructor(name: string = MARGINALIA_DATABASE_NAME) {
    super(name);
    this.version(MARGINALIA_DATABASE_VERSION).stores(SCHEMA_V1);
  }
}

export type CreateDatabaseOptions = {
  name?: string;
};

export function createMarginaliaDatabase(
  options: CreateDatabaseOptions = {},
): MarginaliaDatabase {
  return new MarginaliaDatabase(options.name);
}
